/* EverStride: on phones, the product description sits behind a tappable "Product description" bar */
(function () {
  function init() {
    if (!window.matchMedia || !window.matchMedia('(max-width:680px)').matches) return;
    var wrap = document.querySelector('.evp-product-overview-copy');
    if (!wrap || wrap.querySelector('.evp-overview-details')) return;

    var details = document.createElement('details');
    details.className = 'evp-overview-details';
    var summary = document.createElement('summary');
    summary.textContent = 'Product description';
    details.appendChild(summary);

    var inner = document.createElement('div');
    inner.className = 'evp-overview-inner';
    while (wrap.firstChild) { inner.appendChild(wrap.firstChild); }
    details.appendChild(inner);
    wrap.appendChild(details);

    var style = document.createElement('style');
    style.textContent = [
      'body .evp-product-page .evp-product-overview-copy{border-top:0!important;padding-top:0!important}',
      '.evp-overview-details{border:1px solid #dfe6f0;border-radius:12px;background:#fff;overflow:hidden}',
      '.evp-overview-details>summary{list-style:none;display:flex;align-items:center;justify-content:space-between;min-height:54px;padding:14px 16px;font-weight:800;font-size:16px;color:#10224d;cursor:pointer;-webkit-tap-highlight-color:transparent}',
      '.evp-overview-details>summary::-webkit-details-marker{display:none}',
      '.evp-overview-details>summary::after{content:"";flex:none;width:10px;height:10px;margin-left:12px;border-right:2px solid #2862ed;border-bottom:2px solid #2862ed;transform:rotate(45deg);transition:transform .2s}',
      '.evp-overview-details[open]>summary::after{transform:rotate(-135deg)}',
      '.evp-overview-details[open]>summary{border-bottom:1px solid #e6edf6}',
      '.evp-overview-inner{padding:6px 16px 16px}',
      '.evp-overview-inner .evp-overview-eyebrow{display:none}'
    ].join('\n');
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
